import type { Root, RootOptions } from "react-dom/client";

const APP_ROOT_PROPERTY = "__xanReactRoot";
const INTEGRATIONS_PROPERTY = "__xanIntegrationsInitialized";

type AppRootContainer = HTMLElement & {
  [APP_ROOT_PROPERTY]?: Root;
};

type AppDocument = Document & {
  [INTEGRATIONS_PROPERTY]?: boolean;
};

interface AppRootDependencies {
  createRoot: (container: Element | DocumentFragment, options?: RootOptions) => Root;
  getRootOptions: () => RootOptions | undefined;
}

export function initializeAppIntegrations(appDocument: Document, initialize: () => void): void {
  const bootstrapDocument = appDocument as AppDocument;
  if (bootstrapDocument[INTEGRATIONS_PROPERTY]) {
    return;
  }

  initialize();
  bootstrapDocument[INTEGRATIONS_PROPERTY] = true;
}

export function getOrCreateAppRoot(
  container: HTMLElement,
  { createRoot, getRootOptions }: AppRootDependencies,
): Root {
  const rootContainer = container as AppRootContainer;
  const existingRoot = rootContainer[APP_ROOT_PROPERTY];
  if (existingRoot) {
    return existingRoot;
  }

  const root = createRoot(container, getRootOptions());
  rootContainer[APP_ROOT_PROPERTY] = root;
  return root;
}
